import React, { Fragment } from "react";
import { Helmet } from 'react-helmet';

function About() {
  return (
    <Fragment>
      <Helmet>
        <title>About Us - Geet Suhane</title>
        <meta name="description" content="Learn about Geet Suhane - A platform for music lovers to connect, share, and celebrate the joy of singing." />
      </Helmet>
      <div className="main-content bg-white">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left pe-0">
            <div className="row" style={{ padding: '20px' }}>

              {/* Hero Section */}
              <div style={{
                textAlign: 'center',
                padding: '40px 20px',
                background: 'linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)',
                borderRadius: '16px',
                marginBottom: '30px',
                color: '#fff'
              }}>
                <h1 style={{ fontSize: '32px', fontWeight: '700', marginBottom: '15px' }}>
                  About Geet Suhane
                </h1>
                <p style={{ fontSize: '18px', opacity: 0.9, maxWidth: '600px', margin: '0 auto' }}>
                  A vibrant community where music lovers come together to sing, share, and celebrate
                </p>
              </div>

              {/* Our Story */}
              <div className="col-12" style={{ marginBottom: '30px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '15px', color: '#333' }}>
                  Our Story
                </h2>
                <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                  Geet Suhane was born from a simple idea: everyone deserves a stage to express themselves through music.
                  Whether you're a bathroom singer or a trained vocalist, our platform welcomes all music enthusiasts
                  to share their passion for singing.
                </p>
                <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
                  We believe music transcends boundaries and brings people together. That's why we've created a
                  space where you can perform karaoke, join voice rooms, participate in singing competitions,
                  and connect with fellow music lovers from around the world.
                </p>
              </div>

              {/* Founders Section */}
              <div className="col-12" style={{ marginBottom: '40px' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    borderRadius: '20px',
                    background: 'linear-gradient(135deg, #ffe0e6 0%, #e0e7ff 100%)',
                    color: '#e91e63',
                    fontSize: '14px',
                    fontWeight: '500',
                    marginBottom: '15px'
                  }}>
                    ❤️ Meet Our Founders
                  </span>
                  <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#333', marginBottom: '10px' }}>
                    Built with <span style={{
                      background: 'linear-gradient(135deg, #ff416c, #ff4b2b)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}>Passion for Music</span>
                  </h2>
                  <p style={{ fontSize: '16px', color: '#666', maxWidth: '600px', margin: '0 auto' }}>
                    Geet Suhane was founded to create a global virtual family united by the love of singing
                  </p>
                </div>

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                  gap: '25px'
                }}>
                  {/* Founder 1 - Biren */}
                  <div style={{
                    background: 'linear-gradient(135deg, #e3f2fd 0%, #e8eaf6 100%)',
                    borderRadius: '20px',
                    padding: '30px',
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      right: '-20px',
                      width: '100px',
                      height: '100px',
                      background: 'rgba(255,255,255,0.4)',
                      borderRadius: '50%'
                    }}></div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', marginBottom: '20px' }}>
                      <div style={{ position: 'relative' }}>
                        <div style={{
                          width: '90px',
                          height: '90px',
                          borderRadius: '16px',
                          background: 'linear-gradient(135deg, #2196f3, #3f51b5)',
                          padding: '3px'
                        }}>
                          <img
                            src="https://files.geetsuhane.com/biren/biren.jpg"
                            alt="Biren"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '14px'
                            }}
                          />
                        </div>
                        <div style={{
                          position: 'absolute',
                          bottom: '-8px',
                          right: '-8px',
                          width: '32px',
                          height: '32px',
                          background: 'linear-gradient(135deg, #2196f3, #3f51b5)',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '16px',
                          boxShadow: '0 4px 12px rgba(33,150,243,0.4)'
                        }}>🎵</div>
                      </div>
                      <div>
                        <h3 style={{ fontSize: '22px', fontWeight: '700', color: '#333', margin: '0 0 5px' }}>Biren</h3>
                        <p style={{
                          fontSize: '15px',
                          fontWeight: '600',
                          background: 'linear-gradient(135deg, #2196f3, #3f51b5)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          margin: 0
                        }}>Founder</p>
                        <div style={{ marginTop: '8px' }}>
                          {'⭐'.repeat(5)}
                        </div>
                      </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <span style={{ position: 'absolute', top: '-5px', left: '-5px', fontSize: '24px', opacity: 0.2 }}>❝</span>
                      <p style={{
                        fontSize: '14px',
                        lineHeight: '1.7',
                        color: '#555',
                        paddingLeft: '20px'
                      }}>
                        My vision for Geet Suhane is to create a global virtual family where everyone can enjoy the joy of singing—completely free. Whether you're a beginner or an experienced singer, our platform is your stage. We believe music breaks barriers and brings hearts together, creating lifelong friendships across the world.
                      </p>
                    </div>
                  </div>

                  {/* Founder 2 - Asha */}
                  <div style={{
                    background: 'linear-gradient(135deg, #fce4ec 0%, #f3e5f5 100%)',
                    borderRadius: '20px',
                    padding: '30px',
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      right: '-20px',
                      width: '100px',
                      height: '100px',
                      background: 'rgba(255,255,255,0.4)',
                      borderRadius: '50%'
                    }}></div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', marginBottom: '20px' }}>
                      <div style={{ position: 'relative' }}>
                        <div style={{
                          width: '90px',
                          height: '90px',
                          borderRadius: '16px',
                          background: 'linear-gradient(135deg, #e91e63, #9c27b0)',
                          padding: '3px'
                        }}>
                          <img
                            src="https://files.geetsuhane.com/biren/Asha.jpg"
                            alt="Asha Jha"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '14px'
                            }}
                          />
                        </div>
                        <div style={{
                          position: 'absolute',
                          bottom: '-8px',
                          right: '-8px',
                          width: '32px',
                          height: '32px',
                          background: 'linear-gradient(135deg, #e91e63, #9c27b0)',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '16px',
                          boxShadow: '0 4px 12px rgba(233,30,99,0.4)'
                        }}>🎤</div>
                      </div>
                      <div>
                        <h3 style={{ fontSize: '22px', fontWeight: '700', color: '#333', margin: '0 0 5px' }}>Asha Jha</h3>
                        <p style={{
                          fontSize: '15px',
                          fontWeight: '600',
                          background: 'linear-gradient(135deg, #e91e63, #9c27b0)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          margin: 0
                        }}>Co-Founder</p>
                        <div style={{ marginTop: '8px' }}>
                          {'⭐'.repeat(5)}
                        </div>
                      </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <span style={{ position: 'absolute', top: '-5px', left: '-5px', fontSize: '24px', opacity: 0.2 }}>❝</span>
                      <p style={{
                        fontSize: '14px',
                        lineHeight: '1.7',
                        color: '#555',
                        paddingLeft: '20px'
                      }}>
                        At Geet Suhane, we've built more than just a singing platform—we've created a supportive family. Our mission is to make singing fun and accessible to everyone, regardless of skill level. Join our voice rooms, participate in friendly competitions, and make friends who share your love for music. Most features are completely free because music should have no price tag!
                      </p>
                    </div>
                  </div>
                </div>

                {/* Promise Banner */}
                <div style={{
                  marginTop: '30px',
                  textAlign: 'center'
                }}>
                  <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '15px',
                    padding: '15px 25px',
                    background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                    borderRadius: '16px',
                    border: '1px solid #a5d6a7'
                  }}>
                    <span style={{ fontSize: '28px' }}>🌍</span>
                    <div style={{ textAlign: 'left' }}>
                      <p style={{ margin: 0, fontWeight: '700', color: '#2e7d32', fontSize: '16px' }}>Our Promise</p>
                      <p style={{ margin: 0, color: '#388e3c', fontSize: '14px' }}>A global virtual family united by music—mostly free, always fun!</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Features Grid */}
              <div className="col-12" style={{ marginBottom: '30px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px', color: '#333' }}>
                  What We Offer
                </h2>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                  gap: '20px'
                }}>
                  <div style={{
                    background: '#f8f9fa',
                    padding: '25px',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <span style={{ fontSize: '40px' }}>🎤</span>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', margin: '15px 0 10px', color: '#333' }}>
                      Karaoke Sessions
                    </h3>
                    <p style={{ fontSize: '14px', color: '#666' }}>
                      Sing your favorite songs with our extensive karaoke library
                    </p>
                  </div>

                  <div style={{
                    background: '#f8f9fa',
                    padding: '25px',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <span style={{ fontSize: '40px' }}>🎧</span>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', margin: '15px 0 10px', color: '#333' }}>
                      Voice Rooms
                    </h3>
                    <p style={{ fontSize: '14px', color: '#666' }}>
                      Join live voice rooms and perform for an audience
                    </p>
                  </div>

                  <div style={{
                    background: '#f8f9fa',
                    padding: '25px',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <span style={{ fontSize: '40px' }}>🏆</span>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', margin: '15px 0 10px', color: '#333' }}>
                      Competitions
                    </h3>
                    <p style={{ fontSize: '14px', color: '#666' }}>
                      Participate in singing contests and win exciting rewards
                    </p>
                  </div>

                  <div style={{
                    background: '#f8f9fa',
                    padding: '25px',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <span style={{ fontSize: '40px' }}>🤝</span>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', margin: '15px 0 10px', color: '#333' }}>
                      Community
                    </h3>
                    <p style={{ fontSize: '14px', color: '#666' }}>
                      Connect with music lovers and make new friends
                    </p>
                  </div>
                </div>
              </div>

              {/* Contact Section */}
              <div className="col-12" style={{
                background: '#f8f9fa',
                padding: '30px',
                borderRadius: '16px',
                textAlign: 'center'
              }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px', color: '#333' }}>
                  Get In Touch
                </h2>
                <p style={{ fontSize: '16px', color: '#555', marginBottom: '20px' }}>
                  Have questions or feedback? We'd love to hear from you!
                </p>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '30px',
                  flexWrap: 'wrap'
                }}>
                  <a href="mailto:support@geetsuhane.com" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px'
                  }}>
                    <span style={{ fontSize: '24px' }}>📧</span>
                    support@geetsuhane.com
                  </a>
                  <a href="https://wa.me/13322878300" target="_blank" rel="noopener noreferrer" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    color: '#333',
                    textDecoration: 'none',
                    fontSize: '16px'
                  }}>
                    <span style={{ fontSize: '24px' }}>📱</span>
                    WhatsApp: +1 332 287 8300
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default About;
